import {Injectable} from '@angular/core';
import {catchError, Observable} from 'rxjs';
import {AbstractStationService} from './abstract-station.service';
import {ApiOptions} from '@shared/interfaces/api-options.interface';
import {CreateStationDto, StationDto, UpdateStationDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class StationService extends AbstractStationService<StationDto, CreateStationDto, UpdateStationDto> {
  getUnityInstallXml(id: number, options?: ApiOptions): Observable<string> {
    const url: string = this.url({stationId: id});
    return this.http.get(`${url}/configuration`, {...options, responseType: 'text' as const})
      .pipe(catchError(error => this.handleHttpErrorResponse(error)));
  }
}
